export * from './layer00';
export * from './layer01';
export * from './layer02';



import { activityTemplates as layer01ActivityTemplates } from './layer01';
import { AdminQueuingActivityTemplate } from './layer02';



export const activityTemplates = {
  ...layer01ActivityTemplates,
  AdminQueuingActivityTemplate
};
